import React from 'react';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import CardCategory from '@/presentation/reusables/CardCategory';
import Container from './style';

interface CategoryProps {
  categoryList: any;
  handleSelectCategory: any;
}

const Category = ({ categoryList, handleSelectCategory }: CategoryProps) => (
  <Container data-testid="cmp-Category-list">
    {categoryList &&
      categoryList?.length &&
      categoryList?.map((category: any, index: number) => (
        <CardCategory
          key={IDHelpers.generateID()}
          icon={category.icon}
          onClick={() => {
            handleSelectCategory(category.categoryId);
          }}
          description={category.description}
          title={category.title}
          tabIndex={3 + index}
          testId="cmp-procedure-category"
        />
      ))}
  </Container>
);

export default Category;
